import { Box, Typography } from "@mui/material";

const styles = {
  header: { fontSize: 30 },
};

const PlanDetailsVaBundled = () => {
  return (
    <Box sx={{ my: 2 }}>
      {" "}
      <Typography
        variant="h2"
        sx={styles.header}
        textAlign="center"
        component="div"
      >
        <strong>Virtual Assistant Add Ons</strong>
      </Typography>
      <Typography sx={{ my: 3 }}>
        Your Virtual Assistant already does the heavy lifting — now take it
        further with flexible add-ons built to help you land deals faster.
      </Typography>
    </Box>
  );
};

export default PlanDetailsVaBundled;
